import {initializeMediaUpload} from "./utility/media-uploader";
import {initializeFormSubmission} from "./utility/form-submission"; // Import the form submission function

document.addEventListener('DOMContentLoaded', function () {
    let uploadButton: HTMLElement | null;
    const AmbiklyProduct = {
        init: function () {
            this.handleMediaUpload();
            initializeFormSubmission(); // Call the imported form submission function
        },
        handleMediaUpload: function () {
            const uploadButtons = document.querySelectorAll('.ambikly-image-upload');
            (uploadButtons as NodeListOf<HTMLElement>).forEach((button) => {
                button.addEventListener('click', (e: MouseEvent) => {
                    e.preventDefault();
                    uploadButton = e.currentTarget as HTMLElement;
                    initializeMediaUpload(uploadButton);
                });
            });
        },
    };

    AmbiklyProduct.init();
});
